/**
 * Analytics event constants and helpers
 * Centralized event names and property keys for consistency
 */

// Event Names
export const EVENTS = {
  // Section/Page Tracking
  SECTION_VIEWED: 'section_viewed',
  SCROLL_DEPTH_MILESTONE: 'scroll_depth_milestone',
  TIME_ON_PAGE: 'time_on_page',
  
  // Waitlist Form Events
  WAITLIST_FORM_VIEWED: 'waitlist_form_viewed',
  WAITLIST_FORM_STARTED: 'waitlist_form_started',
  WAITLIST_FIELD_FOCUSED: 'waitlist_field_focused',
  WAITLIST_VALIDATION_ERROR: 'waitlist_validation_error',
  WAITLIST_FORM_SUBMITTED: 'waitlist_form_submitted',
  WAITLIST_SUBMISSION_SUCCESS: 'waitlist_submission_success',
  WAITLIST_SUBMISSION_ERROR: 'waitlist_submission_error',
  WAITLIST_DUPLICATE_EMAIL: 'waitlist_duplicate_email',
  
  // Navigation Events
  HEADER_NAVIGATION_CLICKED: 'header_navigation_clicked',
  CTA_BUTTON_CLICKED: 'cta_button_clicked',
  
  // Engagement Events
  PRICING_PLAN_VIEWED: 'pricing_plan_viewed',
  FAQ_EXPANDED: 'faq_expanded',
  
  // Error Events
  JAVASCRIPT_ERROR: 'javascript_error',
  API_ERROR: 'api_error',
  FORM_VALIDATION_ERROR: 'form_validation_error',
  SLOW_API_RESPONSE: 'slow_api_response',
  NETWORK_ERROR: 'network_error',
  
  // Page Events
  PAGE_LOADED: 'page_loaded',
  BOUNCE_INDICATOR: 'bounce_indicator',
};

// Property Keys
export const PROPERTIES = {
  // Section Properties
  SECTION_NAME: 'section_name',
  SECTION_ID: 'section_id',
  TIME_ON_SECTION: 'time_on_section',
  SCROLL_DEPTH: 'scroll_depth',
  
  // Form Properties
  FORM_FIELD: 'form_field',
  ERROR_TYPE: 'error_type',
  ERROR_MESSAGE: 'error_message',
  TIME_TO_SUBMIT: 'time_to_submit',
  ATTEMPT_NUMBER: 'attempt_number',
  
  // Navigation Properties
  NAVIGATION_TARGET: 'navigation_target',
  CTA_LOCATION: 'cta_location',
  CTA_TEXT: 'cta_text',
  
  // Engagement Properties
  PRICING_PLAN_NAME: 'pricing_plan_name',
  FAQ_QUESTION: 'faq_question',
  FAQ_ID: 'faq_id',
  
  // Error Properties
  ERROR_STATUS_CODE: 'error_status_code',
  API_ENDPOINT: 'api_endpoint',
  RESPONSE_TIME: 'response_time',
  
  // General Properties
  TIMESTAMP: 'timestamp',
  USER_ID: 'user_id',
  SESSION_ID: 'session_id',
};

// Section Names
export const SECTIONS = {
  HERO: 'Hero',
  FEATURES: 'Features',
  HOW_IT_WORKS: 'HowItWorks',
  PRICING: 'Pricing',
  FAQ: 'FAQ',
  WAITLIST: 'Waitlist',
  FOOTER: 'Footer',
};

// Form Fields
export const FORM_FIELDS = {
  NAME: 'name',
  EMAIL: 'email',
  PHONE: 'phone',
};

// Error Types
export const ERROR_TYPES = {
  VALIDATION_ERROR: 'validation_error',
  API_ERROR: 'api_error',
  NETWORK_ERROR: 'network_error',
  DUPLICATE_EMAIL: 'duplicate_email',
  SERVER_ERROR: 'server_error',
};

// Scroll Depth Milestones
export const SCROLL_MILESTONES = [25, 50, 75, 100];

